import React from 'react'
import IonIcon from '@reacticons/ionicons'

const BotUITab = ({
  ChecklauncherImagePreview,
  CheckbotImagePreview,
  limitedPermission,
  launcherImagePreview,
  imageplaceholder,
  handleLauncherImageChange,
  botImagePreview,
  handleBotImageChange,
  botName,
  setBotName,
  welcomeMessage,
  setWelcomeMessage,
  positionSide,
  handlePositionToggle,
  setpositionlabel,
  positionlabel,
  valueRight,
  valueLeft,
  handleRightChange,
  handleLeftChange,
  valueBottom,
  handleBottomChange,
  handleSaveConfig,
  handleResetConfig
}) => {
  return (
    <div className='block mt-4 w-full'>
      {ChecklauncherImagePreview || CheckbotImagePreview ? (
        <div className='mb-5'>
          <small className='font-normal'>*Change default image</small>
        </div>
      ) : null}

      {limitedPermission?.bot_customize_upload_bot_image === false &&
      limitedPermission?.bot_customize_upload_bot_launcher_image === false ? (
        <div className='text-center px-4 py-6 bg-white/60 backdrop-blur-md max-w-[300px] rounded-xl shadow-[0_4px_12px_0_rgba(0,0,0,0.15)]'>
          <IonIcon name='lock-closed-outline' className='text-[24px] mb-2 text-[#7C50DD]' />
          <h2 className='text-xl font-semibold mb-2'>Access Restricted</h2>
          <p className='text-sm text-gray-700 mb-4'>
            Upgrade your plan to upload custom bot and launcher images
          </p>
          <a href='/subscription'>
            <button className='bg-[#7C50DD] rounded-full font-medium text-[12px] px-6 py-2 text-white cursor-pointer shadow hover:shadow-lg transition-all duration-200'>
              Upgrade Now
            </button>
          </a>
        </div>
      ) : (
        <div className='flex flex-col md:flex-row md:space-x-8 md:gap-4 justify-start items-start space-x-0'>
          <div className='flex flex-col items-center space-y-2 '>
            <img
              src={launcherImagePreview || imageplaceholder}
              alt='Launcher'
              style={{ display: 'none' }}
              onLoad={e => {
                e.target.style.display = 'block'
              }}
              className={`w-[70px] h-[70px] ${launcherImagePreview ? 'rounded-full' : ''}`}
            />
            <input
              type='file'
              id='uploadBotLauncherImage'
              style={{ display: 'none' }}
              onChange={handleLauncherImageChange}
            />
            <label
              htmlFor='uploadBotLauncherImage'
              className='bg-[#7C50DD] rounded-[55px] font-[500] text-[10px] w-[128px] h-[36px] flex items-center justify-center text-[#FFF] cursor-pointer shadow-md hover:shadow-lg'
            >
              Upload Launcher Image
            </label>
          </div>

          <div className='flex flex-col items-center space-y-2'>
            <img
              src={botImagePreview || imageplaceholder}
              alt='Bot'
              className=' w-[70px] h-[70px] object-contain'
            />
            <input
              type='file'
              id='uploadBotImage'
              style={{ display: 'none' }}
              onChange={handleBotImageChange}
            />
            <label
              htmlFor='uploadBotImage'
              className='bg-[#7C50DD] rounded-[55px] font-[500] text-[10px] w-[128px] h-[36px] flex items-center justify-center text-[#FFF] cursor-pointer shadow-lg hover:shadow-xl'
            >
              Upload Bot Image
            </label>
          </div>
        </div>
      )}

      <div className='mt-10 block'>
        <div className='block'>
          <p className='font-[400] text-[14px] text-[#2D3748]'>Title</p>
          <input
            type='text'
            className='w-[258px] mt-1 border-[#D1D1D1] border-[1px] h-[38px] rounded-[14px] bg-[#f0eeee] focus:outline-none pl-4 text-[12px] placeholder:text-[12px]'
            placeholder='Chatedge Pro'
            onChange={e => setBotName(e.target.value)}
            value={botName}
          />
        </div>
        <div className='block mt-5'>
          <p className='font-[400] text-[14px] text-[#2D3748]'>Bot Welcome message</p>
          <textarea
            cols='30'
            rows='10'
            className='w-[258px] mt-1 border-[#D1D1D1] border-[1px] h-[130px] rounded-[14px] bg-[#f0eeee] focus:outline-none pl-4 text-[12px] pt-3'
            onChange={e => setWelcomeMessage(e.target.value)}
            value={welcomeMessage}
          />
        </div>

        {/* Position Controls */}
        <div className='block mt-5'>
          <div className='flex items-center space-x-3 mb-3'>
            <p className='font-[400] text-[14px] text-[#2D3748]'>Choose Bot Position</p>
            <div className='flex items-center space-x-3'>
              <label className='inline-flex items-center'>
                <input
                  type='radio'
                  name='positionSide'
                  value='left'
                  checked={positionSide === 'left'}
                  onChange={() => {
                    handlePositionToggle('left')
                    setpositionlabel('Position From Left')
                  }}
                  className='form-radio text-blue-600'
                />
                <span className='ml-2 text-[14px] text-[#2D3748]'>Align Left</span>
              </label>
              <label className='inline-flex items-center'>
                <input
                  type='radio'
                  name='positionSide'
                  value='right'
                  checked={positionSide === 'right'}
                  onChange={() => {
                    handlePositionToggle('right')
                    setpositionlabel('Position From Right')
                  }}
                  className='form-radio text-blue-600'
                />
                <span className='ml-2 text-[14px] text-[#2D3748]'>Align Right</span>
              </label>
            </div>
          </div>

          <div className='flex items-center space-x-3'>
            <p className='font-[400] text-[14px] text-[#2D3748]'>{positionlabel}</p>
          </div>
          <div className='flex items-center space-x-2 mt-1'>
            <input
              type='range'
              className='h-2 bg-gray-300 rounded-lg appearance-none focus:outline-none'
              min='0'
              max='100'
              value={positionSide === 'right' ? valueRight : valueLeft}
              onChange={positionSide === 'right' ? handleRightChange : handleLeftChange}
            />
            <div className='w-[40px] h-[24px] pt-5 pb-5 pr-5 pl-5 flex items-center justify-center bg-gray-200 rounded-lg text-xs text-[#333]'>
              {positionSide === 'right' ? `${valueRight}px` : `${valueLeft}px`}
            </div>
          </div>
        </div>

        {/* Bottom Position */}
        <div className='block mt-5'>
          <div className='flex items-center space-x-3'>
            <p className='font-[400] text-[14px] text-[#2D3748]'>Position From Bottom</p>
          </div>
          <div className='flex items-center space-x-2'>
            <input
              type='range'
              className='h-2 bg-gray-300 rounded-lg appearance-none focus:outline-none '
              min='0'
              max='100'
              value={valueBottom}
              onChange={handleBottomChange}
            />
            <div className='w-[40px] h-[24px] pt-5 pb-5 pr-5 pl-5 flex items-center justify-center bg-gray-200 rounded-lg text-xs text-[#333]'>
              {valueBottom}px
            </div>
          </div>
        </div>

        <div className='mt-5 mb-3 pb-5 flex gap-2'>
          <button
            onClick={handleSaveConfig}
            className='bg-[#232328] w-[85px] h-[39px] rounded-[59px] text-white text-[14px]'
          >
            Save
          </button>
          <button
            onClick={handleResetConfig}
            className='bg-[#232328] w-[85px] h-[39px] rounded-[59px] text-white text-[14px]'
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  )
}

export default BotUITab
